export default __webpack_public_path__ + "static/media/Poster-AmD.4bfce6c8.jpg";